import { render } from "./form-section.vue?vue&type=template&id=2f9a8043"
import script from "./form-section.vue?vue&type=script&lang=js"
export * from "./form-section.vue?vue&type=script&lang=js"

import "./form-section.vue?vue&type=style&index=0&id=2f9a8043&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__